import { defineComponent as _defineComponent } from 'vue'
import { PendingMissionStaffingApplicationFragmentFragment } from "@/gql"
import UserAvatar from "@/components/profile/UserAvatar.vue"
import StateChip from "@/components/widgets/common/StateChip.vue"
import Icon from "@/components/widgets/icons/Icon.vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'PositionDetails',
  props: {
    application: null
  },
  setup(__props: any) {



return { __sfc: true,UserAvatar, StateChip, Icon }
}

})